import Cookies from 'js-cookie';

export class Util {
  public static convertTimeToRepublicEra(timestamp: number): string {
    if (!timestamp) return "-";
    const time = new Date(timestamp * 1000);

    const year = time.getFullYear() - 1911;
    const month = `${
      time.getMonth() + 1 < 10 ? `0${time.getMonth() + 1}` : time.getMonth() + 1
    }`;
    const day = `${
      time.getDate() < 10 ? `0${time.getDate()}` : time.getDate()
    }`;
    const hour = `${
      time.getHours() < 10 ? `0${time.getHours()}` : time.getHours()
    }`;
    const min = `${
      time.getMinutes() < 10 ? `0${time.getMinutes()}` : time.getMinutes()
    }`;

    return `${year}-${month}-${day} ${hour}:${min}`;
  }

  public static isTIDNumber(tidNumber: string): boolean {
    let sum = 0;

    const re = /^\d{8}$/;
    if (!re.test(tidNumber)) {
      return false;
    }

    const tmp = new String("12121241");
    for (let i = 0; i < 8; i++) {
      const s1 = parseInt(tidNumber.substr(i, 1));
      const s2 = parseInt(tmp.substr(i, 1));
      sum += this.tidNumberCal(s1 * s2);
    }
    if (!this.tidNumberValid(sum)) {
      if (tidNumber.substr(6, 1) == "7") {
        return this.tidNumberValid(sum + 1);
      }
    }

    return this.tidNumberValid(sum);
  }

  public static isStoreCode(storeCode: string): boolean {
    return /^006|99\d{12}$/.test(storeCode);
  }

  public static isROCID(id: string) {
    const city = [
      1,
      10,
      19,
      28,
      37,
      46,
      55,
      64,
      39,
      73,
      82,
      2,
      11,
      20,
      48,
      29,
      38,
      47,
      56,
      65,
      74,
      83,
      21,
      3,
      12,
      30
    ];
    id = id.toUpperCase();
    if (!id.match(/^[A-Z]\d{9}$/) && !id.match(/^[A-Z][A-D]\d{8}$/)) {
      return false;
    } else {
      let total = 0;
      const idList = id.split("");
      if (id.match(/^[A-Z]\d{9}$/)) {
        total = city[id[0].charCodeAt(0) - 65];
        for (let i = 1; i <= 8; i++) {
          total += parseInt(idList[i]) * (9 - i);
        }
      }
      total += parseInt(id[9]);
      if (total % 10 == 0) {
        return true;
      } else {
        return false;
      }
    }
  }

  public static isPhone(phone: string) {
    if (/^[09]{2}[0-9]{8}$/.test(phone)) {
      return true;
    } else {
      return false;
    }
  }

  public static isCreditCardNumber(phone: string) {
    if (/^\d{16}$/.test(phone)) {
      return true;
    } else {
      return false;
    }
  }

  public static isMail(mail: string) {
    if (/[\w-]+@([\w-]+\.)+[\w-]+/.test(mail)) {
      return true;
    } else {
      return false;
    }
  }

  private static tidNumberCal(n: number) {
    let sum = 0;
    while (n != 0) {
      sum += n % 10;
      n = (n - (n % 10)) / 10;
    }
    return sum;
  }

  private static tidNumberValid(n: number) {
    return n % 10 == 0 ? true : false;
  }

  public static validateEmail(mail: string): boolean {
    const pattern = /^([A-Za-z0-9_\-.\u4e00-\u9fa5])+@([A-Za-z0-9_\-.])+.([A-Za-z]{2,8})$/;
    if (pattern.test(mail.toLocaleLowerCase())) {
      return true;
    }

    return false;
  }

  public static passReconciliationByCookie(): boolean {
    // 2022/12/27 => 禁止同一帳號在30秒內，重複操作搜尋動作，如30秒內執行時，會跳提示示窗
    // 「請勿於30秒內重複執行搜尋動作，請於30秒後再次嘗試執行，謝謝」
    const nowTime = new Date().getTime();
    const reconciliationCookieSearch = Cookies.get("ReconciliationCookieSearch") as string;
    if (reconciliationCookieSearch && nowTime <= (parseInt(reconciliationCookieSearch) + 15000)) {
      alert('「請勿於15秒內重複執行搜尋動作，請於15秒後再次嘗試執行，謝謝」');
      return false;
    }
    Cookies.set("ReconciliationCookieSearch",nowTime.toString() , { sameSite: 'strict' });

    return true;
  }  
}
